module.exports = __webpack_public_path__ + "static/media/testing.2c749470.svg";